// Captura de un módulo (`FEATURES[].shot`) servida como AVIF/WebP a su ancho.
//
// LDT-717 · Las capturas eran PNG de 1280 px y ~1 MB cada una: la portada
// descargaba tres (3 MB) antes de pintar y /features, diez. Ahora cada captura
// existe en `public/screenshots/` como `<shot>-640`, `<shot>-960` y `<shot>`
// (1280), en `.avif` y `.webp`, y el navegador elige el ancho con `sizes`.
// `width`/`height` son las medidas reales del original (1280×845): reservan
// el hueco antes de que llegue la imagen y el layout no salta (CLS 0).
//
// El `<img>` cae a WebP, no a PNG: todo navegador que ejecuta esta web lo
// soporta, y así ningún camino vuelve a pedir el PNG de 1 MB.

import { SCREENSHOT_SIZE, screenshotFile, screenshotSrcSet } from "./screenshots";

interface ScreenshotProps {
  /** Ruta sin extensión, p. ej. `/screenshots/3_1_home_parque_infantil`. */
  shot: string;
  alt: string;
  className?: string;
  /** Ancho al que se pinta, para que el navegador elija del `srcset`. */
  sizes: string;
  /** Solo para la que esté en el primer pantallazo. */
  priority?: boolean;
}

export default function Screenshot({ shot, alt, className, sizes, priority = false }: ScreenshotProps) {
  return (
    // `display: contents`: el <picture> no crea caja, así el <img> sigue
    // siendo el hijo directo del flex/grid que lo coloca, como antes.
    <picture style={{ display: "contents" }}>
      <source type="image/avif" srcSet={screenshotSrcSet(shot, "avif")} sizes={sizes} />
      <source type="image/webp" srcSet={screenshotSrcSet(shot, "webp")} sizes={sizes} />
      <img
        src={screenshotFile(shot, 1280, "webp")}
        alt={alt}
        className={className}
        width={SCREENSHOT_SIZE.width}
        height={SCREENSHOT_SIZE.height}
        loading={priority ? "eager" : "lazy"}
        decoding="async"
        // Mismo motivo que en ModulePicture: `fetchpriority` en minúsculas por
        // spread para evitar el aviso de React 18.3.
        {...(priority ? ({ fetchpriority: "high" } as Record<string, string>) : {})}
      />
    </picture>
  );
}
